import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/home/favicon.png'
import _imports_1 from '../../assets/images/home/systemOther.png'
import _imports_2 from '../../assets/images/home/systemTwo.png'


const _withScopeId = n => (_pushScopeId("data-v-8151e57e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sanvault-home" }
const _hoisted_2 = { class: "site-header" }
const _hoisted_3 = { class: "site-container header-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "brand",
  href: "#solucao",
  "aria-label": "Sanvault - início"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "42",
    height: "42",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Sanvault")
], -1))
const _hoisted_5 = ["aria-expanded"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/login",
  class: "login-link"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "flaticon-user",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Entrar ")
], -1))
const _hoisted_7 = {
  id: "solucao",
  class: "hero-section"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hero-grid",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = { class: "site-container hero-layout" }
const _hoisted_10 = { class: "hero-copy" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "eyebrow" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "eyebrow-dot" }),
  /*#__PURE__*/_createTextVNode(" Governança de gravações + inteligência operacional ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Transforme cada ligação em informação pesquisável e acionável.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hero-description" }, " Centralize, transcreva e organize as gravações da sua operação para encontrar o que foi dito, acompanhar a qualidade e recuperar evidências em segundos. ", -1))
const _hoisted_14 = { class: "hero-actions" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-whatsapp-logo",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_18 = { class: "hero-note" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-check-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"hero-product\" data-v-8151e57e><div class=\"product-glow\" data-v-8151e57e></div><div class=\"product-window\" data-v-8151e57e><div class=\"window-bar\" data-v-8151e57e><span data-v-8151e57e></span><span data-v-8151e57e></span><span data-v-8151e57e></span><small data-v-8151e57e>Visão da operação</small></div><img src=\"" + _imports_1 + "\" alt=\"Tela real da Sanvault com métricas e gravações da operação\" data-v-8151e57e></div><div class=\"product-badge product-badge--search\" data-v-8151e57e><i class=\"ph ph-magnifying-glass\" aria-hidden=\"true\" data-v-8151e57e></i><span data-v-8151e57e><strong data-v-8151e57e>Busca inteligente</strong>Encontre o que foi dito</span></div><div class=\"product-badge product-badge--transcript\" data-v-8151e57e><i class=\"ph ph-waveform\" aria-hidden=\"true\" data-v-8151e57e></i><span data-v-8151e57e><strong data-v-8151e57e>Transcrição</strong>Voz transformada em dados</span></div></div>", 1)
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<section class=\"positioning-section\" data-v-8151e57e><div class=\"site-container positioning-layout\" data-v-8151e57e><div data-v-8151e57e><span class=\"section-kicker\" data-v-8151e57e>O que muda na sua operação</span><h2 data-v-8151e57e>Gravações deixam de ser arquivos parados e passam a trabalhar pelo seu negócio.</h2></div><p data-v-8151e57e> A Sanvault organiza o histórico das chamadas em um ambiente centralizado, pesquisável e seguro. Assim, gestores encontram respostas mais rápido, acompanham o atendimento e preservam o contexto do que realmente foi falado. </p></div></section><section id=\"beneficios\" class=\"section section--light\" data-v-8151e57e><div class=\"site-container\" data-v-8151e57e><div class=\"section-heading section-heading--center\" data-v-8151e57e><span class=\"section-kicker\" data-v-8151e57e>Resultados que aparecem no dia a dia</span><h2 data-v-8151e57e>Mais clareza para decidir. Menos tempo procurando.</h2><p data-v-8151e57e>Quatro formas de transformar conversas em valor operacional.</p></div><div class=\"outcome-grid\" data-v-8151e57e><article class=\"outcome-card\" data-v-8151e57e><div class=\"icon-box\" data-v-8151e57e><i class=\"ph ph-shield-check\" aria-hidden=\"true\" data-v-8151e57e></i></div><span class=\"card-index\" data-v-8151e57e>01</span><h3 data-v-8151e57e>Prova</h3><p data-v-8151e57e>Recupere rapidamente a ligação e o contexto do que foi combinado com o cliente.</p></article><article class=\"outcome-card\" data-v-8151e57e><div class=\"icon-box\" data-v-8151e57e><i class=\"ph ph-lightning\" aria-hidden=\"true\" data-v-8151e57e></i></div><span class=\"card-index\" data-v-8151e57e>02</span><h3 data-v-8151e57e>Produtividade</h3><p data-v-8151e57e>Localize trechos relevantes pelo texto transcrito, sem ouvir chamada por chamada.</p></article><article class=\"outcome-card\" data-v-8151e57e><div class=\"icon-box\" data-v-8151e57e><i class=\"ph ph-chart-line-up\" aria-hidden=\"true\" data-v-8151e57e></i></div><span class=\"card-index\" data-v-8151e57e>03</span><h3 data-v-8151e57e>Qualidade</h3><p data-v-8151e57e>Acompanhe métricas e sinais de sentimento para orientar a supervisão da operação.</p></article><article class=\"outcome-card\" data-v-8151e57e><div class=\"icon-box\" data-v-8151e57e><i class=\"ph ph-magnifying-glass\" aria-hidden=\"true\" data-v-8151e57e></i></div><span class=\"card-index\" data-v-8151e57e>04</span><h3 data-v-8151e57e>Busca inteligente</h3><p data-v-8151e57e>Pesquise por período, origem, arquivo, sentimento ou conteúdo falado.</p></article></div></div></section><section id=\"como-funciona\" class=\"section section--navy\" data-v-8151e57e><div class=\"site-container\" data-v-8151e57e><div class=\"section-heading section-heading--inverted\" data-v-8151e57e><span class=\"section-kicker section-kicker--cyan\" data-v-8151e57e>Da ligação à informação</span><h2 data-v-8151e57e>Uma camada de inteligência sobre a sua operação de voz.</h2><p data-v-8151e57e>Integre o que você já usa e torne o histórico de chamadas útil para a gestão.</p></div><div class=\"steps-grid\" data-v-8151e57e><article class=\"step-card\" data-v-8151e57e><span class=\"step-number\" data-v-8151e57e>01</span><div class=\"step-icon\" data-v-8151e57e><i class=\"ph ph-cloud-arrow-up\" aria-hidden=\"true\" data-v-8151e57e></i></div><h3 data-v-8151e57e>Integre as chamadas</h3><p data-v-8151e57e>Envie gravações pela API ou conecte seu servidor via SFTP para automatizar a entrada dos arquivos.</p></article><article class=\"step-card\" data-v-8151e57e><span class=\"step-number\" data-v-8151e57e>02</span><div class=\"step-icon\" data-v-8151e57e><i class=\"ph ph-waveform\" aria-hidden=\"true\" data-v-8151e57e></i></div><h3 data-v-8151e57e>Enriqueça o conteúdo</h3><p data-v-8151e57e>Converta voz em texto e adicione análise de sentimento para ampliar a leitura das interações.</p></article><article class=\"step-card\" data-v-8151e57e><span class=\"step-number\" data-v-8151e57e>03</span><div class=\"step-icon\" data-v-8151e57e><i class=\"ph ph-magnifying-glass\" aria-hidden=\"true\" data-v-8151e57e></i></div><h3 data-v-8151e57e>Pesquise e acompanhe</h3><p data-v-8151e57e>Encontre conversas por filtros e conteúdo transcrito, ou acompanhe métricas nos painéis da operação.</p></article></div></div></section><section class=\"section section--cases\" data-v-8151e57e><div class=\"site-container\" data-v-8151e57e><div class=\"section-heading\" data-v-8151e57e><span class=\"section-kicker\" data-v-8151e57e>Onde a Sanvault gera valor</span><h2 data-v-8151e57e>Informação certa para os momentos que mais importam.</h2></div><div class=\"cases-grid\" data-v-8151e57e><article class=\"case-card\" data-v-8151e57e><span class=\"case-tag\" data-v-8151e57e>Agendamento</span><h3 data-v-8151e57e>Entenda por que oportunidades não avançam.</h3><p data-v-8151e57e>Localize chamadas, revise abordagens e recupere detalhes informados pelo cliente.</p><i class=\"ph ph-calendar-check\" aria-hidden=\"true\" data-v-8151e57e></i></article><article class=\"case-card\" data-v-8151e57e><span class=\"case-tag\" data-v-8151e57e>Vendas</span><h3 data-v-8151e57e>Encontre objeções e conversas decisivas.</h3><p data-v-8151e57e>Pesquise termos falados e retome negociações com mais contexto.</p><i class=\"ph ph-trend-up\" aria-hidden=\"true\" data-v-8151e57e></i></article><article class=\"case-card\" data-v-8151e57e><span class=\"case-tag\" data-v-8151e57e>Qualidade</span><h3 data-v-8151e57e>Supervisione com mais contexto e agilidade.</h3><p data-v-8151e57e>Use métricas, transcrição e sentimento para direcionar a análise das chamadas.</p><i class=\"ph ph-headset\" aria-hidden=\"true\" data-v-8151e57e></i></article><article class=\"case-card\" data-v-8151e57e><span class=\"case-tag\" data-v-8151e57e>Evidências</span><h3 data-v-8151e57e>Recupere o histórico do que foi falado.</h3><p data-v-8151e57e>Acesse gravação e transcrição em um único fluxo sempre que precisar esclarecer um atendimento.</p><i class=\"ph ph-file-magnifying-glass\" aria-hidden=\"true\" data-v-8151e57e></i></article></div></div></section><section class=\"section product-proof-section\" data-v-8151e57e><div class=\"site-container\" data-v-8151e57e><div class=\"section-heading section-heading--center\" data-v-8151e57e><span class=\"section-kicker\" data-v-8151e57e>Produto real, operação visível</span><h2 data-v-8151e57e>Do panorama geral ao detalhe de cada chamada.</h2><p data-v-8151e57e>Acompanhe volume, duração, processamento e encontre a interação que precisa analisar.</p></div><div class=\"proof-stack\" data-v-8151e57e><div class=\"proof-window proof-window--dashboard\" data-v-8151e57e><div class=\"proof-copy\" data-v-8151e57e><span data-v-8151e57e>Visão gerencial</span><h3 data-v-8151e57e>Métricas organizadas em um só lugar</h3><p data-v-8151e57e>Tenha uma leitura rápida do volume, duração e processamento das gravações da operação.</p></div><div class=\"proof-image\" data-v-8151e57e><div class=\"proof-shot\" data-v-8151e57e><img src=\"" + _imports_1 + "\" alt=\"Dashboard real da Sanvault com métricas de gravações\" loading=\"lazy\" data-v-8151e57e></div></div></div><div class=\"proof-window proof-window--search\" data-v-8151e57e><div class=\"proof-copy\" data-v-8151e57e><span data-v-8151e57e>Busca operacional</span><h3 data-v-8151e57e>Chegue à conversa certa com poucos filtros</h3><p data-v-8151e57e>Refine por data, identificação, origem, transcrição e sentimento, depois ouça a gravação.</p></div><div class=\"proof-image\" data-v-8151e57e><div class=\"proof-shot\" data-v-8151e57e><img src=\"" + _imports_2 + "\" alt=\"Tela real da Sanvault para pesquisa e reprodução de gravações\" loading=\"lazy\" data-v-8151e57e></div></div></div></div></div></section>", 5)
const _hoisted_26 = {
  id: "recursos",
  class: "section section--resources"
}
const _hoisted_27 = { class: "site-container resources-layout" }
const _hoisted_28 = { class: "resources-intro" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-kicker" }, "Capacidades da plataforma", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Recursos para organizar, entender e recuperar cada conversa.", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " A Sanvault combina gestão de gravações e inteligência sobre voz sem exigir que sua equipe troque toda a infraestrutura de telefonia. ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-up-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"resource-list\" data-v-8151e57e><div class=\"resource-item\" data-v-8151e57e><i class=\"ph ph-text-align-left\" aria-hidden=\"true\" data-v-8151e57e></i><div data-v-8151e57e><h3 data-v-8151e57e>Transcrição automática</h3><p data-v-8151e57e>Transforme o áudio em texto para leitura e pesquisa.</p></div></div><div class=\"resource-item\" data-v-8151e57e><i class=\"ph ph-magnifying-glass\" aria-hidden=\"true\" data-v-8151e57e></i><div data-v-8151e57e><h3 data-v-8151e57e>Busca pelo conteúdo falado</h3><p data-v-8151e57e>Encontre gravações a partir de termos presentes na transcrição.</p></div></div><div class=\"resource-item\" data-v-8151e57e><i class=\"ph ph-smiley\" aria-hidden=\"true\" data-v-8151e57e></i><div data-v-8151e57e><h3 data-v-8151e57e>Análise de sentimento</h3><p data-v-8151e57e>Use sinais positivos, neutros e negativos para orientar a análise.</p></div></div><div class=\"resource-item\" data-v-8151e57e><i class=\"ph ph-funnel\" aria-hidden=\"true\" data-v-8151e57e></i><div data-v-8151e57e><h3 data-v-8151e57e>Filtros avançados</h3><p data-v-8151e57e>Pesquise por data, origem, arquivo, sentimento e transcrição.</p></div></div><div class=\"resource-item\" data-v-8151e57e><i class=\"ph ph-chart-bar\" aria-hidden=\"true\" data-v-8151e57e></i><div data-v-8151e57e><h3 data-v-8151e57e>Métricas e tempo real</h3><p data-v-8151e57e>Acompanhe indicadores gerais, performance e processamento dos uploads.</p></div></div><div class=\"resource-item\" data-v-8151e57e><i class=\"ph ph-users-three\" aria-hidden=\"true\" data-v-8151e57e></i><div data-v-8151e57e><h3 data-v-8151e57e>Usuários e acessos</h3><p data-v-8151e57e>Organize o uso da plataforma por usuários e permissões.</p></div></div><div class=\"resource-item\" data-v-8151e57e><i class=\"ph ph-plugs-connected\" aria-hidden=\"true\" data-v-8151e57e></i><div data-v-8151e57e><h3 data-v-8151e57e>API e SFTP</h3><p data-v-8151e57e>Integre a entrada das gravações ao fluxo atual da sua telefonia.</p></div></div><div class=\"resource-item\" data-v-8151e57e><i class=\"ph ph-cloud-check\" aria-hidden=\"true\" data-v-8151e57e></i><div data-v-8151e57e><h3 data-v-8151e57e>Armazenamento escalável</h3><p data-v-8151e57e>Mantenha o histórico acessível sem ampliar infraestrutura física.</p></div></div></div>", 1)
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<section class=\"governance-section\" data-v-8151e57e><div class=\"site-container governance-layout\" data-v-8151e57e><div class=\"governance-symbol\" aria-hidden=\"true\" data-v-8151e57e><i class=\"ph ph-shield-check\" data-v-8151e57e></i></div><div data-v-8151e57e><span class=\"section-kicker section-kicker--cyan\" data-v-8151e57e>Governança começa com organização</span><h2 data-v-8151e57e>Gravações centralizadas, acessíveis e sob controle da sua operação.</h2><p data-v-8151e57e> Reúna o histórico em nuvem, organize acessos e mantenha as conversas disponíveis para consulta quando sua equipe precisar de contexto. </p></div><ul data-v-8151e57e><li data-v-8151e57e><i class=\"ph ph-check\" aria-hidden=\"true\" data-v-8151e57e></i> Controle de acesso por usuário</li><li data-v-8151e57e><i class=\"ph ph-check\" aria-hidden=\"true\" data-v-8151e57e></i> Armazenamento seguro em nuvem</li><li data-v-8151e57e><i class=\"ph ph-check\" aria-hidden=\"true\" data-v-8151e57e></i> Acesso rápido às gravações</li><li data-v-8151e57e><i class=\"ph ph-check\" aria-hidden=\"true\" data-v-8151e57e></i> Opção de limitar o espaço armazenado</li></ul></div></section>", 1)
const _hoisted_35 = {
  id: "preco",
  class: "section pricing-section"
}
const _hoisted_36 = { class: "site-container" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-heading section-heading--center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-kicker" }, "Infraestrutura transparente"),
  /*#__PURE__*/_createElementVNode("h2", null, "Comece pequeno e cresça junto com a sua operação."),
  /*#__PURE__*/_createElementVNode("p", null, "Você paga pelo espaço utilizado. Transcrição e análise de sentimento são cobradas separadamente.")
], -1))
const _hoisted_38 = { class: "pricing-layout" }
const _hoisted_39 = { class: "price-card" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-label" }, "Armazenamento em nuvem", -1))
const _hoisted_41 = { class: "price" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "R$", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/ GB", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Plataforma, métricas, reprodução, usuários e integrações já incluídos.", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-check-circle",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" API ou conexão SFTP")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-check-circle",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Dashboard e performance")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-check-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-check-circle",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Conversão automática de arquivos")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_50 = { class: "calculator-card" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "calculator-heading" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-box" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "ph ph-calculator",
      "aria-hidden": "true"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Simule seu investimento"),
    /*#__PURE__*/_createElementVNode("h3", null, "Quanto sua operação pode utilizar?")
  ])
], -1))
const _hoisted_52 = { class: "calculator-fields" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Quantidade de arquivos", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tamanho médio por arquivo (MB)", -1))
const _hoisted_55 = {
  class: "calculator-result",
  "aria-live": "polite"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Estimativa mensal de armazenamento", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Funcionalidades de IA são cobradas à parte.", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "calculator-note" }, " A conversão para GSM pode reduzir o espaço utilizado e tornar o valor final ainda menor. ", -1))
const _hoisted_59 = { class: "final-cta-section" }
const _hoisted_60 = { class: "site-container final-cta" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-kicker section-kicker--cyan" }, "Sua operação já produz os dados"),
  /*#__PURE__*/_createElementVNode("h2", null, "Agora faça essas conversas trabalharem a favor do seu negócio.")
], -1))
const _hoisted_62 = { class: "final-actions" }
const _hoisted_63 = ["href"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-whatsapp-logo",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_66 = { class: "site-footer" }
const _hoisted_67 = { class: "site-container footer-layout" }
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-brand\" data-v-8151e57e><a class=\"brand brand--footer\" href=\"#solucao\" data-v-8151e57e><img src=\"" + _imports_0 + "\" width=\"42\" height=\"42\" alt=\"\" data-v-8151e57e><span data-v-8151e57e>Sanvault</span></a><p data-v-8151e57e> Transformamos gravações de ligações em informação organizada, pesquisável e útil para a gestão da sua operação. </p><small data-v-8151e57e>CNPJ: 57.916.345/0001-07</small></div><div class=\"footer-column\" data-v-8151e57e><h3 data-v-8151e57e>Plataforma</h3><a href=\"#beneficios\" data-v-8151e57e>Benefícios</a><a href=\"#como-funciona\" data-v-8151e57e>Como funciona</a><a href=\"#recursos\" data-v-8151e57e>Recursos</a><a href=\"#preco\" data-v-8151e57e>Preço</a></div>", 2)
const _hoisted_70 = { class: "footer-column" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Acesso", -1))
const _hoisted_72 = { class: "footer-column" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Contato e legal", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:contato@sanvault.com.br" }, "contato@sanvault.com.br", -1))
const _hoisted_75 = ["href"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "site-container footer-bottom" }, [
  /*#__PURE__*/_createElementVNode("span", null, "© 2026 Sanvault. Todos os direitos reservados."),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.linkedin.com/company/sanvault-tecnologia/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "LinkedIn"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.facebook.com/people/Sanvault-Tecnologia/61579472255039/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Facebook")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          class: "menu-toggle",
          type: "button",
          "aria-expanded": _ctx.isMenuActive,
          "aria-controls": "main-navigation",
          "aria-label": "Abrir menu de navegação",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.isMenuActive ? 'ph ph-x' : 'ph ph-list'),
            "aria-hidden": "true"
          }, null, 2)
        ], 8, _hoisted_5),
        _createElementVNode("nav", {
          id: "main-navigation",
          class: _normalizeClass(['main-navigation', { 'is-open': _ctx.isMenuActive }]),
          "aria-label": "Navegação principal"
        }, [
          _createElementVNode("a", {
            href: "#solucao",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
          }, "Solução"),
          _createElementVNode("a", {
            href: "#beneficios",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
          }, "Benefícios"),
          _createElementVNode("a", {
            href: "#como-funciona",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
          }, "Como funciona"),
          _createElementVNode("a", {
            href: "#recursos",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
          }, "Recursos"),
          _createElementVNode("a", {
            href: "#preco",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
          }, "Preço"),
          _hoisted_6
        ], 2)
      ])
    ]),
    _createElementVNode("main", null, [
      _createElementVNode("section", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("a", {
                href: _ctx.whatsappUrl,
                class: "action-button action-button--outline",
                target: "_blank",
                rel: "noopener noreferrer"
              }, [
                _hoisted_16,
                _createTextVNode(" Solicitar demonstração ")
              ], 8, _hoisted_15),
              _createVNode(_component_router_link, {
                to: "/register",
                class: "action-button action-button--blue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Criar conta grátis "),
                  _hoisted_17
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", null, [
                _createTextVNode(" Teste com "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.getGbFree) + " GB gratuitos", 1),
                _createTextVNode(", sem compromisso. Depois, você informa uma forma de pagamento válida. ")
              ])
            ])
          ]),
          _hoisted_20
        ])
      ]),
      _hoisted_21,
      _createElementVNode("section", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _hoisted_30,
            _hoisted_31,
            _createVNode(_component_router_link, {
              to: "/register",
              class: "text-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Testar a plataforma "),
                _hoisted_32
              ]),
              _: 1
            })
          ]),
          _hoisted_33
        ])
      ]),
      _hoisted_34,
      _createElementVNode("section", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("article", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("strong", null, _toDisplayString(_ctx.formattedValue(_ctx.getServicePrice)), 1),
                _hoisted_43
              ]),
              _hoisted_44,
              _createElementVNode("ul", null, [
                _hoisted_45,
                _hoisted_46,
                _createElementVNode("li", null, [
                  _hoisted_47,
                  _createTextVNode(" " + _toDisplayString(_ctx.getGbFree) + " GB gratuitos para avaliação", 1)
                ]),
                _hoisted_48
              ]),
              _createVNode(_component_router_link, {
                to: "/register",
                class: "action-button action-button--blue action-button--full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Criar conta grátis "),
                  _hoisted_49
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("label", null, [
                  _hoisted_53,
                  _withDirectives(_createElementVNode("input", {
                    ref: "qtdFiles",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.quantidade) = $event)),
                    type: "number",
                    min: "0",
                    inputmode: "numeric",
                    placeholder: "Ex.: 10.000",
                    onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.calcularValorFinal && _ctx.calcularValorFinal(...args)))
                  }, null, 544), [
                    [
                      _vModelText,
                      _ctx.quantidade,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _hoisted_54,
                  _withDirectives(_createElementVNode("input", {
                    ref: "sizeFiles",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tamanhoMedio) = $event)),
                    type: "number",
                    min: "0",
                    step: "0.01",
                    inputmode: "decimal",
                    placeholder: "Ex.: 2,5",
                    onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.calcularValorFinal && _ctx.calcularValorFinal(...args)))
                  }, null, 544), [
                    [
                      _vModelText,
                      _ctx.tamanhoMedio,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("strong", null, "R$ " + _toDisplayString(_ctx.valorFinal), 1),
                _hoisted_57
              ]),
              _hoisted_58
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("a", {
              href: _ctx.whatsappUrl,
              class: "action-button action-button--outline-dark",
              target: "_blank",
              rel: "noopener noreferrer"
            }, [
              _hoisted_64,
              _createTextVNode(" Solicitar demonstração ")
            ], 8, _hoisted_63),
            _createVNode(_component_router_link, {
              to: "/register",
              class: "action-button action-button--light"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Criar conta grátis "),
                _hoisted_65
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _hoisted_68,
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          _createVNode(_component_router_link, { to: "/login" }, {
            default: _withCtx(() => [
              _createTextVNode("Entrar")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/register" }, {
            default: _withCtx(() => [
              _createTextVNode("Criar conta")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/documentation" }, {
            default: _withCtx(() => [
              _createTextVNode("Documentação")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_72, [
          _hoisted_73,
          _hoisted_74,
          _createVNode(_component_router_link, { to: "/terms" }, {
            default: _withCtx(() => [
              _createTextVNode("Termos e condições")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/privacy-policy" }, {
            default: _withCtx(() => [
              _createTextVNode("Política de privacidade")
            ]),
            _: 1
          }),
          _createElementVNode("a", {
            href: _ctx.whatsappUrl,
            target: "_blank",
            rel: "noopener noreferrer"
          }, "WhatsApp comercial", 8, _hoisted_75)
        ])
      ]),
      _hoisted_76
    ])
  ]))
}